import React from "react";
import SmoothScroll from "@/components/landing/SmoothScroll";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import About from "@/components/landing/About";
import Gallery from "@/components/landing/Gallery";
import Features from "@/components/landing/Features";
import Testimonials from "@/components/landing/Testimonials";
import Newsletter from "@/components/landing/Newsletter";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <SmoothScroll>
      <main
        data-testid="landing-page"
        className="relative bg-[#0a0f1d] text-white font-sans-pro overflow-x-hidden"
      >
        <Navbar />
        <Hero />
        <Marquee />
        <About />
        <Gallery />
        <Features />
        <Testimonials />
        <Newsletter />
        <Footer />
      </main>
    </SmoothScroll>
  );
}
